/**
 * Facets All-Products Scope Handler
 * Version: 5.1 - Fixed nav menu blocking issue
 */

(function() {
  'use strict';

  var CONFIG = {
    ALL_PRODUCTS_PATH: '/collections/all-products',
    FACET_FORM_SELECTOR: 'form#facet-form[is="facet-form"]',
    HYDRATION_TIMEOUT: 2500,
    OBSERVER_DEBOUNCE: 150,
    DEBUG: false
  };

  var state = {
    isHydrating: false,
    lastCanonicalPath: null,
    initialized: false
  };

  function log() {
    if (CONFIG.DEBUG) {
      var args = ['[Facets v5.1]'].concat(Array.prototype.slice.call(arguments));
      console.log.apply(console, args);
    }
  }

  function getCanonicalPath() {
    var path = window.location.pathname.replace(/\/$/, '');
    
    if (path.indexOf('/collections/') === 0 && path !== CONFIG.ALL_PRODUCTS_PATH) {
      return path;
    }
    
    var form = document.querySelector(CONFIG.FACET_FORM_SELECTOR);
    var formCanonical = form ? form.getAttribute('data-canonical-path') : null;
    if (formCanonical && formCanonical !== CONFIG.ALL_PRODUCTS_PATH) {
      return formCanonical.replace(/\/$/, '');
    }
    
    return path;
  }

  function hasActiveFilters() {
    var params = new URLSearchParams(window.location.search);
    var keys = params.keys();
    var result = keys.next();
    while (!result.done) {
      if (result.value.indexOf('filter.') === 0 || result.value === 'sort_by') {
        return true;
      }
      result = keys.next();
    }
    return false;
  }

  function getSectionId() {
    var form = document.querySelector(CONFIG.FACET_FORM_SELECTOR);
    return form ? form.getAttribute('section-id') : null;
  }

  function isCollectionPage() {
    return window.location.pathname.indexOf('/collections/') === 0;
  }

  function isAllProductsPage() {
    var path = window.location.pathname.replace(/\/$/, '');
    return path === CONFIG.ALL_PRODUCTS_PATH;
  }

  function setHydratingState(isHydrating) {
    document.documentElement.classList.toggle('facets-hydrating', isHydrating);
    log('Hydrating state:', isHydrating);
  }

  function syncFacetForms(canonicalPath) {
    var forms = document.querySelectorAll(CONFIG.FACET_FORM_SELECTOR);
    
    forms.forEach(function(form) {
      form.setAttribute('action', CONFIG.ALL_PRODUCTS_PATH);
      form.setAttribute('data-canonical-path', canonicalPath);
      
      var scopeInputs = form.querySelectorAll('input[data-scope-tag]');
      scopeInputs.forEach(function(input) {
        input.remove();
      });
    });
    
    log('Forms synced. Canonical:', canonicalPath, 'Forms found:', forms.length);
  }

  function rewriteUrlToCanonical(canonicalPath) {
    var currentPath = window.location.pathname.replace(/\/$/, '');
    
    if (currentPath === canonicalPath) {
      return;
    }
    
    var url = new URL(window.location.href);
    url.pathname = canonicalPath;
    
    window.history.replaceState(window.history.state, '', url.toString());
    log('URL rewritten to:', url.toString());
  }

  function fetchFacetHTML(sectionId) {
    var url = new URL(CONFIG.ALL_PRODUCTS_PATH, window.location.origin);
    url.searchParams.set('section_id', sectionId);
    
    log('Fetching facets from:', url.toString());
    
    return fetch(url.toString(), {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Accept': 'text/html'
      }
    }).then(function(response) {
      if (!response.ok) {
        throw new Error('Fetch failed with status: ' + response.status);
      }
      return response.text();
    });
  }

  function parseFacetForms(html) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    return Array.from(doc.querySelectorAll(CONFIG.FACET_FORM_SELECTOR));
  }

  function findFormByType(forms, isSidebar) {
    var formsArray = Array.from(forms);
    return formsArray.find(function(form) {
      return form.hasAttribute('update-on-change') === isSidebar;
    }) || formsArray[0];
  }

  function replaceFacetForms(newForms, canonicalPath, sectionId) {
    var currentForms = document.querySelectorAll(CONFIG.FACET_FORM_SELECTOR);
    
    if (currentForms.length === 0 || newForms.length === 0) {
      log('No forms to replace');
      return false;
    }
    
    var currentDrawer = findFormByType(currentForms, false);
    var currentSidebar = findFormByType(currentForms, true);
    var newDrawer = findFormByType(newForms, false);
    var newSidebar = findFormByType(newForms, true);
    
    [newDrawer, newSidebar].forEach(function(form) {
      if (!form) return;
      
      form.setAttribute('action', CONFIG.ALL_PRODUCTS_PATH);
      form.setAttribute('data-canonical-path', canonicalPath);
      
      if (sectionId) {
        form.setAttribute('section-id', sectionId);
      }
      
      form.querySelectorAll('input[data-scope-tag]').forEach(function(input) {
        input.remove();
      });
    });
    
    if (currentDrawer && newDrawer) {
      var clone = newDrawer.cloneNode(true);
      currentDrawer.replaceWith(clone);
      log('Drawer form replaced');
    }
    
    if (currentSidebar && newSidebar && currentSidebar !== currentDrawer) {
      var clone = newSidebar.cloneNode(true);
      currentSidebar.replaceWith(clone);
      log('Sidebar form replaced');
    }
    
    return true;
  }

  function reinitializeCustomElements() {
    var forms = document.querySelectorAll(CONFIG.FACET_FORM_SELECTOR);
    
    forms.forEach(function(form) {
      if (form.matches(':defined') && typeof form.connectedCallback === 'function') {
        try {
          form.connectedCallback();
        } catch (e) {}
      }
    });
  }

  function hydrateFacets() {
    if (state.isHydrating) {
      log('Already hydrating, skipping');
      return Promise.resolve();
    }
    
    var sectionId = getSectionId();
    if (!sectionId) {
      log('No section ID found, cannot hydrate');
      return Promise.resolve();
    }
    
    var canonicalPath = getCanonicalPath();
    
    if (isAllProductsPage()) {
      log('On all-products page, skipping hydration');
      syncFacetForms(canonicalPath);
      return Promise.resolve();
    }
    
    state.isHydrating = true;
    setHydratingState(true);
    
    var safetyTimeout = setTimeout(function() {
      setHydratingState(false);
      log('Safety timeout triggered');
    }, CONFIG.HYDRATION_TIMEOUT);
    
    return fetchFacetHTML(sectionId)
      .then(function(html) {
        var newForms = parseFacetForms(html);
        var replaced = replaceFacetForms(newForms, canonicalPath, sectionId);
        
        if (replaced) {
          syncFacetForms(canonicalPath);
          reinitializeCustomElements();
          log('Hydration complete');
        }
      })
      .catch(function(error) {
        console.warn('[Facets v5.1] Hydration error:', error);
      })
      .finally(function() {
        clearTimeout(safetyTimeout);
        setHydratingState(false);
        state.isHydrating = false;
      });
  }

  function handleFacetUpdate() {
    var canonicalPath = getCanonicalPath();
    
    log('Facet update event received');
    
    syncFacetForms(canonicalPath);
    rewriteUrlToCanonical(canonicalPath);
  }

  /**
   * Handle clicks on "clear filters" links.
   * ONLY intercepts clicks within the facets UI, NOT navigation menu links.
   */
  function handleClearFiltersClick(event) {
    var link = event.target.closest('a');
    
    if (!link) return;
    
    var href = link.getAttribute('href');
    if (!href) return;
    
    // Check if this link points to all-products
    var isAllProductsLink = 
      href === CONFIG.ALL_PRODUCTS_PATH || 
      href === CONFIG.ALL_PRODUCTS_PATH + '/' ||
      href.indexOf(CONFIG.ALL_PRODUCTS_PATH + '?') === 0;
    
    if (!isAllProductsLink) return;
    
    // IMPORTANT: Only intercept if this is a facet-related link, NOT a nav menu link
    var isFacetLink = link.hasAttribute('is') && link.getAttribute('is') === 'facet-link';
    var isInsideFacets = link.closest('.facets-vertical, .facets-drawer, facet-drawer, .collection__facets, .active-facets, .collection-top-bar__filters');
    var isClearButton = link.classList.contains('facets__clear') || link.closest('.facets__clear');
    
    // If it's NOT a facet-related link, let it navigate normally
    if (!isFacetLink && !isInsideFacets && !isClearButton) {
      log('Allowing navigation to all-products (not a facet link)');
      return;
    }
    
    // It IS a facet link - check if it's clearing filters
    var hasNoFilters = href.indexOf('filter.') === -1;
    
    if (hasNoFilters) {
      event.preventDefault();
      event.stopPropagation();
      
      var canonicalPath = getCanonicalPath();
      log('Redirecting clear action to canonical:', canonicalPath);
      
      window.location.href = canonicalPath;
    }
  }

  function initialize() {
    if (!isCollectionPage()) {
      log('Not a collection page, skipping initialization');
      return Promise.resolve();
    }
    
    var canonicalPath = getCanonicalPath();
    
    if (state.lastCanonicalPath && state.lastCanonicalPath !== canonicalPath) {
      log('Collection changed from', state.lastCanonicalPath, 'to', canonicalPath);
    }
    state.lastCanonicalPath = canonicalPath;
    
    if (isAllProductsPage()) {
      syncFacetForms(canonicalPath);
      setHydratingState(false);
      log('All-products page - forms synced');
      return Promise.resolve();
    }
    
    if (hasActiveFilters()) {
      log('Filters active - syncing forms and URL');
      syncFacetForms(canonicalPath);
      rewriteUrlToCanonical(canonicalPath);
      setHydratingState(false);
      return Promise.resolve();
    } else {
      log('No filters - starting hydration');
      return hydrateFacets();
    }
  }

  var observerTimeout = null;
  
  function handleMutations() {
    clearTimeout(observerTimeout);
    
    observerTimeout = setTimeout(function() {
      if (!isCollectionPage()) return;
      
      var canonicalPath = getCanonicalPath();
      
      if (state.lastCanonicalPath !== canonicalPath) {
        log('Mutation observer detected collection change');
        state.lastCanonicalPath = canonicalPath;
        initialize();
      } else {
        syncFacetForms(canonicalPath);
      }
    }, CONFIG.OBSERVER_DEBOUNCE);
  }

  function setup() {
    log('Setting up...');
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
    
    window.addEventListener('popstate', function() {
      log('Popstate event');
      setTimeout(initialize, 0);
    });
    
    window.addEventListener('pageshow', function(event) {
      if (event.persisted) {
        log('Page restored from bfcache');
        initialize();
      }
    });
    
    document.addEventListener('facet:update', handleFacetUpdate, true);
    document.addEventListener('facet:updated', handleFacetUpdate, true);
    
    document.addEventListener('click', handleClearFiltersClick, true);
    
    var observer = new MutationObserver(handleMutations);
    
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: false,
      characterData: false
    });
    
    log('Setup complete');
  }

  setup();

  window.__FACETS__ = {
    setDebug: function(enabled) {
      CONFIG.DEBUG = !!enabled;
      console.log('[Facets v5.1] Debug mode:', CONFIG.DEBUG);
    },
    reinit: initialize,
    getState: function() {
      return {
        isHydrating: state.isHydrating,
        lastCanonicalPath: state.lastCanonicalPath,
        initialized: state.initialized,
        currentCanonical: getCanonicalPath(),
        hasFilters: hasActiveFilters(),
        sectionId: getSectionId(),
        formCount: document.querySelectorAll(CONFIG.FACET_FORM_SELECTOR).length
      };
    },
    hydrate: hydrateFacets
  };

})();